import ApiService from "@/common/api.service";
import JwtService from "@/common/jwt.service";

import {
  FETCH_PROFILE,
  FETCH_PROFILE_FOLLOW,
  FETCH_PROFILE_UNFOLLOW,
  PROFILE_SET_FORM,
  PROFILE_INIT,
  PROFILE_SET_ADDRESS
} from "./actions.type";
import {
  SET_PROFILE,
  SET_PROFILE_FORM,
  SET_ADDRESS_PROFILE
} from "./mutations.type";

const state = {
  errors: {},
  // profile: null,
  profile: null,
  orders: [
    {
      createdAt: "2021年10月9日",
      no: "xxxxxxxxxxxxxx",
      receiver: "〇〇〇〇",
      deliveryStatus: "出荷済み",
      product: {
        id: 1,
        img: "",
        name: "天下一品ラーメン こってり",
        description: "ラーメンのみ 4食セット",
        price: "3,300",
        quantity: "2"
      }
    },
    {
      createdAt: "2021年10月9日",
      No: "xxxxxxxxxxxxxy",
      receiver: "〇〇〇〇",
      deliveryStatus: "出荷済み",

      product: {
        id: 1,
        img: "",
        name: "天下一品ラーメン こってり",
        description: "ラーメンのみ 4食セット",
        price: "3,300",
        quantity: "2"
      }
    }
  ],
  productFavorites: [
    {
      id: 1,
      img: "",
      name: "天下一品ラーメン こってり",
      description: "ラーメンのみ 4食セット",
      price: "3,300"
    }
  ]
};

const getters = {
  profile(state) {
    return state.profile;
  },
  orders(state) {
    return state.orders;
  },
  productFavorites(state) {
    return state.productFavorites;
  }
};

const actions = {
  [FETCH_PROFILE](context) {
    const params = {
      refresh_token: JwtService.getRefreshToken()
    };
    return ApiService.post("v1/customers/refresh_token", params)
      .then(({ data }) => {
        context.commit(SET_PROFILE, data);
        return data;
      })
      .catch(() => {
        // #todo SET_ERROR cannot work in multiple states
        // context.commit(SET_ERROR, response.data.errors)
      });
  },
  [FETCH_PROFILE_FOLLOW](context, payload) {
    const { username } = payload;
    return ApiService.post(`v1/profiles/${username}/follow`)
      .then(({ data }) => {
        context.commit(SET_PROFILE, data.profile);
        return data;
      })
      .catch(() => {
        // #todo SET_ERROR cannot work in multiple states
        // context.commit(SET_ERROR, response.data.errors)
      });
  },
  [FETCH_PROFILE_UNFOLLOW](context, payload) {
    const { username } = payload;
    return ApiService.delete(`v1/profiles/${username}/follow`).then(({ data }) => {
      context.commit(SET_PROFILE, data.profile);
    });
  },
  [PROFILE_SET_FORM]({ commit }, payload) {
    commit(SET_PROFILE_FORM, payload);
  },
  [PROFILE_INIT](context, payload) {
    context.commit(SET_PROFILE, payload);
  },
  [PROFILE_SET_ADDRESS]({ commit }, payload) {
    commit(SET_ADDRESS_PROFILE, payload);
  }
};

const mutations = {
  // [SET_ERROR] (state, error) {
  //   state.errors = error
  // },
  [SET_PROFILE](state, profile) {
    state.profile = profile;
    state.errors = {};
  },
  [SET_PROFILE_FORM](state, payload) {
    state.profile = { ...state.profile, ...payload };
  },
  [SET_ADDRESS_PROFILE](state, payload) {
    state.profile.addresses[0] = { ...state.profile.addresses[0], ...payload };
    state.profile = { ...state.profile };
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
